import { createContext, useContext, useEffect, useState } from 'react';
import { en } from './en';
import { fr } from './fr';

const dictionaries = { en, fr };
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('deluxe-lang') === 'fr' ? 'fr' : 'en';
    } catch {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('deluxe-lang', lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = dictionaries[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useSeo(page) {
  const { t } = useLanguage();
  useEffect(() => {
    const meta = t.seo[page];
    if (!meta) return;
    document.title = meta.title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute('content', meta.desc);
  }, [t, page]);
}
